<div class="it-header-slim-wrapper user-bar-custom pb-0">
  <div class="container">
    <div class="it-header-slim-wrapper-content user-bar-size">
      <a
        class="it-opener navbar-brand"
        href="https://www.regione.abruzzo.it/"
        target="_blank"
      >
        <span class="body-sm">{{ "REG_ABRUZZO" | translate | titlecase }}</span>
        <span class="visually-hidden">{{ "EXT_LINK" | translate }}</span>
      </a>
      <div class="it-header-slim-right-zone gap-4 h-100">
        <div
          class="nav-item dropdown"
          role="navigation"
          [attr.aria-labelledby]="language + '-lng'"
        >
          <button
            #lang_dropdown
            [attr.id]="language + '-lng'"
            role="button"
            tabindex="0"
            class="dropdown-toggle lang-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [attr.aria-label]="
              language === 'it'
                ? ('SEL_LNG' | translate) + ' ' + ('ITA' | translate)
                : ('SEL_LNG' | translate) + ' ' + ('ENG' | translate)
            "
            aria-controls="panel1"
            (click)="toggleDropdownLang()"
            (keyup)="onAnchorKeyUp($event, 'lang', 'lingua')"
          >
            <span *ngIf="language === 'en'" class="link-md">{{
              "ENG" | translate
            }}</span>
            <span *ngIf="language === 'it'" class="link-md">{{
              "ITA" | translate
            }}</span>
            <svg
              aria-hidden="true"
              class="icon icon-xs d-none d-lg-block mx-2"
              style="fill: #06c"
              [ngClass]="{
                'toggle-up': langOpened,
                'toggle-down': !langOpened
              }"
            >
              <use href="assets/sprite.svg#it-expand"></use>
            </svg>
          </button>
          <div
            #menuLingua
            id="panel1"
            class="dropdown-menu"
            role="menu"
            [attr.aria-label]="'LIST_LNG' | translate"
          >
            <div class="row">
              <div class="col-12">
                <div class="link-list-wrapper">
                  <ul class="link-list">
                    <li
                      *ngIf="language != 'it'"
                      role="menuitem"
                      class="dropdown-item list-item"
                    >
                      <a
                        tabindex="0"
                        (click)="changeLanguage('it')"
                        id="it-lng"
                        (keyup.enter)="changeLanguage('it')"
                        class="cursor-pointer"
                        ><span
                          >{{ "IT" | translate }}
                          <span class="visually-hidden">{{
                            "SELECTED" | translate
                          }}</span></span
                        ></a
                      >
                    </li>
                    <li
                      *ngIf="language != 'en'"
                      role="menuitem"
                      class="dropdown-item list-item"
                    >
                      <a
                        id="en-lng"
                        tabindex="0"
                        class="cursor-pointer"
                        (click)="changeLanguage('en')"
                        (keyup.enter)="changeLanguage('en')"
                        ><span>{{ "EN" | translate }}</span></a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="nav-item dropdown user-bar-user-info-menu h-100"
          *ngIf="isAuthenticated"
          aria-labelledby="usrpnl"
        >
          <button
            #profile_dropdown
            role="button"
            id="usrpnl"
            tabindex="0"
            class="nav-link dropdown-toggle profile-dropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-controls="panel2"
            aria-haspopup="true"
            [attr.aria-label]="'USR_OPT' | translate"
            (click)="toggleDropdownProfile()"
            (keyup)="onAnchorKeyUp($event, 'profile', 'utente')"
          >
            <div role="navigation" class="d-flex align-items-center">
              <i class="fas fa-user-circle fa-xl custom-profile-icon mr-2"></i>
              <div class="link-md username d-none d-md-block">
                {{ nomeUtente }}
              </div>
            </div>
            <svg
              aria-hidden="true"
              class="icon icon-xs d-block mx-2"
              [ngClass]="{
                'toggle-up': profileOpened,
                'toggle-down': !profileOpened
              }"
            >
              <use href="assets/sprite.svg#it-expand"></use>
            </svg>
          </button>
          <div
            #menuUtente
            class="dropdown-menu"
            id="panel2"
            role="menu"
            [attr.aria-label]="'MENU_OPZ_USR' | translate"
          >
            <div class="row justify-content-center">
              <div class="col-10 py-2">
                <div class="link-list-wrapper">
                  <ul class="link-list">
                    <div class="row">
                      <div class="col">
                        <p class="label etichetta-ruolo mb-0 mb-1">
                          {{ "ROLE" | translate | uppercase }}
                        </p>
                        <p class="ruolo">
                          {{ roleCardTitle | translate }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="row mt-3"
                      *ngIf="roleListExeptCurrent.length > 0"
                    >
                      <div class="col-12">
                        <p class="label etichetta-ruolo mb-0 mb-1">
                          {{ "CHANGE_ROLE" | translate | uppercase }}
                        </p>
                        <a
                          *ngFor="let role of roleListExeptCurrent"
                          (click)="changeRole(role)"
                          tabindex="0"
                          class="list-item cursor-pointer d-block"
                        >
                          <span class="link-sm">{{
                            getRoleString(role) | translate
                          }}</span>
                        </a>
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-12">
                        <a
                          (click)="logout()"
                          tabindex="0"
                          class="exit-link list-item cursor-pointer"
                        >
                          <span
                            class="fa fa-external-link"
                            aria-hidden="true"
                          ></span
                          ><span class="link-md mx-2">{{
                            "EXIT" | translate
                          }}</span>
                        </a>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
